'use client';
import type { MenuChildrenDataInner } from '@generated-client/strapi';
import * as Dialog from '@radix-ui/react-dialog';
import { createStateful } from '@trwl/shared/lib/stateful';
import { Sidebar } from '@trwl/shared/ui/sidebar';
import { BrandsSidebar } from '@trwl/widgets/nav/brands';
import { useUnit } from 'effector-react';
import { AnimatePresence } from 'framer-motion';
import Link from 'next/link';
import { CgClose } from 'react-icons/cg';

import s from './sidebar.module.scss';

export const NavigationSidebar = createStateful<
  object,
  { menu: MenuChildrenDataInner[] }
>(({ state, setState, menu }) => {
  const active = useUnit(state);

  return (
    <Dialog.Root
      open={active.active}
      onOpenChange={(open) =>
        setState({
          active: open,
        })
      }
    >
      <AnimatePresence>
        {active.active && (
          <Dialog.Portal>
            <Sidebar.Content
              asChild
              className="border-none md:w-[600px] py-[92px] px-[64px] z-[2000] w-[100%] justify-between outline-none md:rounded-tr-[12px] md:rounded-br-[12px] md:border-r-[2px] md:border-r-[#F6F6F6]"
            >
              <CgClose
                className="absolute cursor-pointer w-7 h-7 fill-[#B6B6B6]"
                onClick={() =>
                  setState({
                    active: false,
                  })
                }
                style={{
                  top: 25,
                  right: 25,
                }}
              />
              <div className="flex flex-col gap-[5px]">
                {menu.map((route) =>
                  (route.attributes?.link ?? '').includes('#brands') ? (
                    <Link
                      key={route.id}
                      className={`relative max-[367px]:text-[32px] max-[460px]:text-[48px] w-auto text-[64px] whitespace-nowrap before:content-[''] before:absolute before:l-0 before:bottom-[-5px] before:w-[0%] before:h-[2px] before:bg-black hover:before:w-[100%] ${s.link}`}
                      onClick={() =>
                        BrandsSidebar.store.stateChanged({
                          active: true,
                        })
                      }
                      href="#"
                    >
                      {route.attributes?.title}
                    </Link>
                  ) : (
                    <Link
                      key={route.id}
                      className={`relative max-[367px]:text-[32px] max-[460px]:text-[48px] w-auto text-[64px] whitespace-nowrap before:content-[''] before:absolute before:l-0 before:bottom-[-5px] before:w-[0%] before:h-[2px] before:bg-black hover:before:w-[100%] ${s.link}`}
                      onClick={() =>
                        setState({
                          active: false,
                        })
                      }
                      href={route.attributes?.link ?? ''}
                    >
                      {route.attributes?.title}
                    </Link>
                  ),
                )}
              </div>
            </Sidebar.Content>
          </Dialog.Portal>
        )}
      </AnimatePresence>
    </Dialog.Root>
  );
});
